(function () {
  "use strict";

  function formatMoney(pence) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP"
    }).format((Number(pence) || 0) / 100);
  }

  function sanitizeRegistration(value) {
    let cleaned = String(value || "")
      .toUpperCase()
      .replace(/[^A-Z0-9 ]/g, "")
      .replace(/\s+/g, " ");

    cleaned = cleaned.replace(/^\s+/, "");
    return cleaned.slice(0, 9);
  }

  function escapeHtml(str) {
    return String(str || "")  
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function isLikelyStandardUkReg(input) {
    const stripped = String(input || "").replace(/\s/g, "");
    return /^[A-Z]{2}[0-9]{2}[A-Z]{3}$/.test(stripped);
  }

  function slugStyle(style) {
    return String(style || "")
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }

  function parsePrefill() {
    const params = new URLSearchParams(window.location.search);
    return {
      reg: params.get("reg") || "",
      style: params.get("style") || "",
      size: params.get("size") || "",
      badge: params.get("badge") || "",
      border: params.get("border") || "",
      legalUse: params.get("legalUse") || "",
      position: params.get("position") || ""
    };
  }

  function buildDisplayRegistration(registration, legalUse) {
    const clean = sanitizeRegistration(registration);
    if (!clean) return "";

    if (clean.indexOf(" ") !== -1) {
      return clean;
    }

    if (legalUse === "Road Legal" && isLikelyStandardUkReg(clean)) {
      const stripped = clean.replace(/\s/g, "");
      return stripped.slice(0, 4) + " " + stripped.slice(4);
    }

    return clean.replace(/\s/g, "");
  }

  function getRegistrationFitString(registration, legalUse) {
    const clean = sanitizeRegistration(registration);
    if (!clean) return "";

    if (legalUse === "Road Legal" && isLikelyStandardUkReg(clean)) {
      const stripped = clean.replace(/\s/g, "");
      return stripped.slice(0, 4) + " " + stripped.slice(4);
    }

    return clean;
  }

  function getRegistrationCharCount(displayReg) {
    return String(displayReg || "").replace(/\s/g, "").length;
  }

  function buildLegalTextWidthMm(displayReg, rules) {
    if (!displayReg) return 0;

    const groups = displayReg.split(" ").filter(Boolean);
    let width = 0;

    groups.forEach(function (group, groupIndex) {
      const chars = group.split("");

      chars.forEach(function (char, charIndex) {
        if (char === "1") {
          width += rules.oneWidthMm;
        } else if (char === "I") {
          width += rules.iWidthMm;
        } else {
          width += rules.defaultWidthMm;
        }

        if (charIndex < chars.length - 1) {
          width += rules.charGapMm;
        }
      });

      if (groupIndex < groups.length - 1) {
        width += rules.groupGapMm;
      }
    });

    return width;
  }

  function getPracticalCharWidthMm(char) {
    const widths = {
      "1": 18,
      "I": 14,
      "J": 26,
      "L": 30,
      "T": 34,
      "M": 48,
      "W": 48
    };

    if (widths[char] != null) return widths[char];
    if (/[0-9]/.test(char)) return 40;
    return 43;
  }

  function buildPracticalTextWidthMm(displayReg) {
    if (!displayReg) return 0;

    const groups = displayReg.split(" ").filter(Boolean);
    let width = 0;

    groups.forEach(function (group, groupIndex) {
      const chars = group.split("");

      chars.forEach(function (char, charIndex) {
        width += getPracticalCharWidthMm(char);

        if (charIndex < chars.length - 1) {
          width += 10;
        }
      });

      if (groupIndex < groups.length - 1) {
        width += 40;
      }
    });

    return width;
  }

  function getSafeWidthMm(sizeKey, legalUse, badge) {
    const hasBadge = badge && badge !== "None";

    if (legalUse !== "Road Legal") {
      return 490;
    }

    if (sizeKey === "Standard Size") return hasBadge ? 438 : 490;
    if (sizeKey === '18" Short') return hasBadge ? 0 : 438;
    if (sizeKey === '17" Short') return hasBadge ? 0 : 410;
    if (sizeKey === '16" Short') return hasBadge ? 0 : 390;
    if (sizeKey === '13" Short') return hasBadge ? 0 : 250;
    if (sizeKey === "Hex 7") return 370;
    if (sizeKey === "Hex 6") return 320;
    if (sizeKey === "Hex 5") return 270;

    return 490;
  }

  function getRoadLegalGreatFitLimit(sizeKey, hasBadge) {
    if (sizeKey === "Standard Size") return 7;
    if (sizeKey === '18" Short') return hasBadge ? 6 : 7;
    if (sizeKey === '17" Short') return hasBadge ? 6 : 7;
    if (sizeKey === '16" Short') return hasBadge ? 5 : 6;
    if (sizeKey === '13" Short') return hasBadge ? 4 : 5;
    if (sizeKey === "Hex 7") return 7;
    if (sizeKey === "Hex 6") return 6;
    if (sizeKey === "Hex 5") return 5;
    return 7;
  }

  function getHexMetrics() {
    return {
      topInsetRatio: 17.5 / 520,
      bottomInsetRatio: 25 / 520,
      sidePointYRatio: 32 / 111
    };
  }

  function getHexOverlayBoost(sizeKey) {
    if (sizeKey === "Hex 7") return 14;
    if (sizeKey === "Hex 6") return 20;
    if (sizeKey === "Hex 5") return 26;
    return 0;
  }

  function getHexOverlayOverscan(sizeKey) {
    if (sizeKey === "Hex 7") return 20;
    if (sizeKey === "Hex 6") return 26;
    if (sizeKey === "Hex 5") return 36;
    return 8;
  }

  function buildFitLayout(registration, legalUse, badge, border, sizeConfig, sizeKey, rules) {
    const displayReg = getRegistrationFitString(registration, legalUse);
    const isHex = sizeConfig.shape === "hex";
    const borderMm = isHex ? 0 : (border === "Border" ? 2 : 0);
    const hasBadge = badge && badge !== "None";
    const charCount = getRegistrationCharCount(displayReg);

    const textWidthMm = legalUse === "Road Legal"
      ? buildLegalTextWidthMm(displayReg, rules)
      : buildPracticalTextWidthMm(displayReg);

    const safeWidthMm = getSafeWidthMm(sizeKey, legalUse, badge);
    const availableMm = safeWidthMm - (borderMm * 2);

    let fitState = "green";
    let fitLabel = "Perfect fit";
    const warnings = [];

    if (!displayReg || !displayReg.replace(/\s/g, "")) {
      fitState = "amber";
      fitLabel = "Awaiting reg";
      warnings.push({
        state: "amber",
        text: "Enter a registration to see a live fit calculation."
      });
    } else if (isHex && hasBadge) {
      fitState = "red";
      fitLabel = "Badge not allowed";
      warnings.push({
        state: "red",
        text: "Hex plates cannot have a flag or badge."
      });
    } else if (legalUse === "Road Legal") {
      const greatFitLimit = getRoadLegalGreatFitLimit(sizeKey, hasBadge);

      if (charCount <= greatFitLimit) {
        fitState = "green";
        fitLabel = "Perfect fit";
        warnings.push({
          state: "green",
          text: "This size comfortably fits the registration."
        });
      } else {
        fitState = "red";
        fitLabel = "Does not fit";
        warnings.push({
          state: "red",
          text: "This registration does not fit the selected size."
        });
      }
    } else if (textWidthMm > availableMm || availableMm <= 0) {
      fitState = "red";
      fitLabel = "Does not fit";
      warnings.push({
        state: "red",
        text: "This registration does not fit the selected size."
      });
    } else {
      fitState = "green";
      fitLabel = "Perfect fit";
      warnings.push({
        state: "green",
        text: "This size comfortably fits the registration."
      });
    }

    if (isHex && border !== "None") {
      warnings.push({
        state: "amber",
        text: "Hex plates cannot have a border. The preview has disabled it automatically."
      });
    }

    return {
      borderMm: borderMm,
      fitState: fitState,
      fitLabel: fitLabel,
      warnings: warnings,
      displayReg: buildDisplayRegistration(registration, legalUse),
      fitReg: displayReg,
      textWidthMm: textWidthMm,
      availableMm: availableMm,
      charCount: charCount
    };
  }

  function getRegistrationArea(sizeConfig, rules, badge) {
    const hasBadge = badge && badge !== "None";

    if (!hasBadge) {
      return {
        startX: 14,
        endX: sizeConfig.widthMm - 14
      };
    }

    return {
      startX: rules.badgeWidthMm + 10,
      endX: sizeConfig.widthMm - 14
    };
  }

  function getTextCenterX(sizeConfig, rules, badge) {
    const area = getRegistrationArea(sizeConfig, rules, badge);
    return area.startX + ((area.endX - area.startX) / 2);
  }

  function getFontSizeMm() {
    return 95;
  }

  function getLetterSpacingEm() {
    return 0.020;
  }

  function getBorderInsetMm(sizeConfig) {
    if (sizeConfig.shape === "hex") return 0;
    return 8;
  }

  function buildPlateShapeSvg(sizeConfig, fill) {
    return '<rect x="0" y="0" width="' + sizeConfig.widthMm + '" height="' + sizeConfig.heightMm + '" rx="4" ry="4" fill="' + fill + '"/>';
  }

  function buildHexOverlaySvg(sizeConfig, sizeKey, overlayFill) {
    if (sizeConfig.shape !== "hex") return "";

    const w = sizeConfig.widthMm;
    const h = sizeConfig.heightMm;
    const hex = getHexMetrics();
    const boost = getHexOverlayBoost(sizeKey);
    const overscan = getHexOverlayOverscan(sizeKey);

    const topInset = (w * hex.topInsetRatio) + boost;
    const bottomInset = (w * hex.bottomInsetRatio) + boost;
    const sidePointY = h * hex.sidePointYRatio;

    let svg = "";

    svg += '<polygon points="' +
      (-overscan) + ',' + (-overscan) + ' ' +
      topInset + ',' + (-overscan) + ' ' +
      '0,' + sidePointY + ' ' +
      bottomInset + ',' + (h + overscan) + ' ' +
      (-overscan) + ',' + (h + overscan) +
      '" fill="' + overlayFill + '"/>';

    svg += '<polygon points="' +
      (w + overscan) + ',' + (-overscan) + ' ' +
      (w - topInset) + ',' + (-overscan) + ' ' +
      w + ',' + sidePointY + ' ' +
      (w - bottomInset) + ',' + (h + overscan) + ' ' +
      (w + overscan) + ',' + (h + overscan) +
      '" fill="' + overlayFill + '"/>';

    return svg;
  }
function buildSvgTextContent(displayReg) {
  const parts = displayReg.split(" ");

  if (parts.length === 2) {
    return '<tspan>' + escapeHtml(parts[0]) + '</tspan>' +
      '<tspan dx="0.12em">' + escapeHtml(parts[1]) + '</tspan>';
  }

  return escapeHtml(displayReg);
}

function buildTextElement(displayReg, options) {
  let svg = "";

  svg += '<text';
  svg += ' x="' + options.x + '"';
  svg += ' y="' + options.y + '"';
  svg += ' text-anchor="middle"';
  svg += ' font-family="CharlesWrightMuzz, Charles Wright, Arial Narrow, Arial, sans-serif"';
  svg += ' font-size="' + options.fontSize + '"';
  svg += ' font-weight="400"';
  svg += ' letter-spacing="' + options.letterSpacing + 'em"';
  svg += ' text-rendering="geometricPrecision"';
  svg += ' dominant-baseline="alphabetic"';

  if (options.fill !== undefined) svg += ' fill="' + options.fill + '"';
  if (options.stroke !== undefined) svg += ' stroke="' + options.stroke + '"';
  if (options.strokeWidth !== undefined) svg += ' stroke-width="' + options.strokeWidth + '"';
  if (options.strokeLinejoin) svg += ' stroke-linejoin="' + options.strokeLinejoin + '"';
  if (options.strokeLinecap) svg += ' stroke-linecap="' + options.strokeLinecap + '"';
  if (options.opacity !== undefined) svg += ' opacity="' + options.opacity + '"';
  if (options.filter) svg += ' filter="' + options.filter + '"';

  svg += '>';
  svg += buildSvgTextContent(displayReg);
  svg += '</text>';

  return svg;
}

function buildStyleDefs(id) {
  let svg = "";

  svg += '<defs>';

    svg += '<filter id="' + id + 'BevelLight" x="-50%" y="-50%" width="200%" height="200%">';
  svg += '<feGaussianBlur in="SourceAlpha" stdDeviation="1.5" result="blur"/>';
svg += '<feSpecularLighting in="blur" surfaceScale="2.2" specularConstant="0.22" specularExponent="28" lighting-color="#ffffff" result="specLight">';
  svg += '<feDistantLight azimuth="90" elevation="45"/>';
  svg += '</feSpecularLighting>';
  svg += '<feComposite in="specLight" in2="SourceAlpha" operator="in" result="specOut"/>';
svg += '<feComposite in="SourceGraphic" in2="specOut" operator="arithmetic" k1="0" k2="1" k3="0.28" k4="0"/>';
  svg += '</filter>';

  svg += '<filter id="' + id + 'SoftRaise" x="-20%" y="-30%" width="140%" height="170%">';
  svg += '<feDropShadow dx="1.2" dy="1.8" stdDeviation="1" flood-color="#000000" flood-opacity="0.55"/>';
  svg += '</filter>';

  svg += '<filter id="' + id + 'HardRaise" x="-20%" y="-30%" width="140%" height="170%">';
svg += '<feDropShadow dx="0.9" dy="1.1" stdDeviation="0.35" flood-color="#000000" flood-opacity="0.55"/>';
  svg += '</filter>';

svg += '<linearGradient id="' + id + 'BlackGloss" x1="0%" y1="0%" x2="0%" y2="100%">';
svg += '<stop offset="0%" stop-color="#444444"/>';
svg += '<stop offset="18%" stop-color="#1b1b1b"/>';
svg += '<stop offset="54%" stop-color="#020202"/>';
svg += '<stop offset="100%" stop-color="#181818"/>';
svg += '</linearGradient>';

svg += '<linearGradient id="' + id + 'BevelFace" x1="0%" y1="0%" x2="100%" y2="100%">';
svg += '<stop offset="0%" stop-color="#6a6a6a"/>';
svg += '<stop offset="12%" stop-color="#e5e5e5"/>';
svg += '<stop offset="24%" stop-color="#1a1a1a"/>';
svg += '<stop offset="52%" stop-color="#020202"/>';
svg += '<stop offset="74%" stop-color="#8a8a8a"/>';
svg += '<stop offset="100%" stop-color="#050505"/>';
svg += '</linearGradient>';

  svg += '<linearGradient id="' + id + 'BevelBlack" x1="0%" y1="0%" x2="100%" y2="100%">';
  svg += '<stop offset="0%" stop-color="#303030"/>';
  svg += '<stop offset="20%" stop-color="#050505"/>';
  svg += '<stop offset="52%" stop-color="#000000"/>';
  svg += '<stop offset="76%" stop-color="#242424"/>';
  svg += '<stop offset="100%" stop-color="#050505"/>';
  svg += '</linearGradient>';

  svg += '<linearGradient id="' + id + 'GelBlack" x1="0%" y1="0%" x2="0%" y2="100%">';
  svg += '<stop offset="0%" stop-color="#383838"/>';
  svg += '<stop offset="18%" stop-color="#090909"/>';
  svg += '<stop offset="70%" stop-color="#000000"/>';
  svg += '<stop offset="100%" stop-color="#151515"/>';
  svg += '</linearGradient>';
  svg += '<filter id="' + id + 'BevelAcrylic" x="-20%" y="-30%" width="140%" height="170%" color-interpolation-filters="sRGB">';
  svg += '<feGaussianBlur in="SourceAlpha" stdDeviation="1.2" result="blur"/>';
  svg += '<feSpecularLighting in="blur" surfaceScale="4" specularConstant="0.9" specularExponent="18" lighting-color="#ffffff" result="spec">';
  svg += '<fePointLight x="-500" y="-900" z="900"/>';
  svg += '</feSpecularLighting>';
  svg += '<feComposite in="spec" in2="SourceAlpha" operator="in" result="specOut"/>';
  svg += '<feOffset in="SourceAlpha" dx="1.1" dy="1.3" result="shadowOffset"/>';
  svg += '<feGaussianBlur in="shadowOffset" stdDeviation="0.45" result="shadowBlur"/>';
  svg += '<feFlood flood-color="#000000" flood-opacity="0.55" result="shadowColor"/>';
  svg += '<feComposite in="shadowColor" in2="shadowBlur" operator="in" result="shadow"/>';
  svg += '<feMerge>';
  svg += '<feMergeNode in="shadow"/>';
  svg += '<feMergeNode in="SourceGraphic"/>';
  svg += '<feMergeNode in="specOut"/>';
  svg += '</feMerge>';
  svg += '</filter>';
  
  svg += '</defs>';

  return svg;
}

function buildStyledRegistrationTextSvg(displayReg, style, x, y, fontSize, letterSpacing, id) {
  const styleKey = slugStyle(style);
  let svg = buildStyleDefs(id);

if (styleKey === "4d-obsidian") {
  svg += buildTextElement(displayReg, {
    x: x,
    y: y,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#020202",
    stroke: "#111111",
    strokeWidth: 4.4,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    filter: "url(#" + id + "HardRaise)"
  });

  svg += buildTextElement(displayReg, {
    x: x,
    y: y,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#050505",
    stroke: "#242424",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  });

  return svg;
}

if (styleKey === "4d-ghost") {
  svg += buildTextElement(displayReg, {
    x: x + 0.7,
    y: y + 0.9,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#000000",
    opacity: 0.42,
    filter: "url(#" + id + "HardRaise)"
  });

  svg += buildTextElement(displayReg, {
    x: x,
    y: y,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#050505",
    stroke: "#1f1f1f",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  });

  svg += buildTextElement(displayReg, {
    x: x - 0.35,
    y: y - 0.4,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "none",
    stroke: "#6c6c6c",
    strokeWidth: 1.2,
    strokeLinejoin: "round",
    opacity: 0.65
  });

  svg += buildTextElement(displayReg, {
    x: x + 0.45,
    y: y + 0.45,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.4,
    strokeLinejoin: "round",
    opacity: 0.85
  });

  return svg;
}

if (styleKey === "4d-bevelled-edge") {

  // soft physical shadow behind raised acrylic
  svg += buildTextElement(displayReg, {
    x: x + 2.2,
    y: y + 2.6,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#000000",
    opacity: 0.34,
    filter: "url(#" + id + "SoftRaise)"
  });

  // darker lower/right angled face
  svg += buildTextElement(displayReg, {
    x: x + 1.15,
    y: y + 1.25,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#050505",
    opacity: 0.92
  });

  // lighter upper/left angled face
  svg += buildTextElement(displayReg, {
    x: x - 0.9,
    y: y - 0.9,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#3d3d3d",
    opacity: 0.72
  });

  // glossy black top face, slightly smaller so bevel shows around it
  svg += buildTextElement(displayReg, {
    x: x,
    y: y,
    fontSize: fontSize * 0.91,
    letterSpacing: letterSpacing + 0.004,
    fill: "url(#" + id + "BlackGloss)"
  });

  // small specular catch, subtle not silver
  svg += buildTextElement(displayReg, {
    x: x - 0.45,
    y: y - 0.65,
    fontSize: fontSize * 0.82,
    letterSpacing: letterSpacing + 0.006,
    fill: "#ffffff",
    opacity: 0.12
  });

  return svg;
}

if (styleKey === "3d-gel") {
  svg += buildTextElement(displayReg, {
    x: x,
    y: y,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#050505",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeLinejoin: "round",
    filter: "url(#" + id + "BevelAcrylic)"
  });

  return svg;
}

if (styleKey === "4d-acrylic" || styleKey === "4d-float") {
    svg += buildTextElement(displayReg, {
      x: x + 2,
      y: y + 2.2,
      fontSize: fontSize,
      letterSpacing: letterSpacing,
      fill: "#000000",
      opacity: 0.55
    });

    svg += buildTextElement(displayReg, {
      x: x,
      y: y,
      fontSize: fontSize,
      letterSpacing: letterSpacing,
      fill: "#050505",
      filter: "url(#" + id + "HardRaise)"
    });

    return svg;
  }

if (styleKey === "5d") {
  svg += buildTextElement(displayReg, {
    x: x,
    y: y,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#050505",
    stroke: "#000000",
    strokeWidth: 1.2,
    strokeLinejoin: "round",
    filter: "url(#" + id + "BevelAcrylic)"
  });

  return svg;
}

  return buildTextElement(displayReg, {
    x: x,
    y: y,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    fill: "#111111"
  });
}
  function buildBrokenBorderSvg(sizeConfig, borderMm, badge, rules, markCenterX) {
    if (!borderMm || sizeConfig.shape === "hex") return "";

    const inset = getBorderInsetMm(sizeConfig);
    const left = inset;
    const top = inset;
    const right = sizeConfig.widthMm - inset;
    const bottom = sizeConfig.heightMm - inset;
    const hasBadge = badge && badge !== "None";

    const makerGapWidth = 74;
    const makerGapCenter = markCenterX || (sizeConfig.widthMm / 2);
    const makerGapStart = makerGapCenter - (makerGapWidth / 2);
    const makerGapEnd = makerGapCenter + (makerGapWidth / 2);

    let svg = "";

    if (!hasBadge) {
      svg += '<line x1="' + left + '" y1="' + top + '" x2="' + right + '" y2="' + top + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
      svg += '<line x1="' + right + '" y1="' + top + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
      svg += '<line x1="' + left + '" y1="' + top + '" x2="' + left + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
      svg += '<line x1="' + left + '" y1="' + bottom + '" x2="' + makerGapStart + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
      svg += '<line x1="' + makerGapEnd + '" y1="' + bottom + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
      return svg;
    }

    const badgeRight = rules.badgeWidthMm;
    const borderStartX = badgeRight + inset;

    svg += '<line x1="' + borderStartX + '" y1="' + top + '" x2="' + right + '" y2="' + top + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
    svg += '<line x1="' + right + '" y1="' + top + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
    svg += '<line x1="' + borderStartX + '" y1="' + top + '" x2="' + borderStartX + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
    svg += '<line x1="' + borderStartX + '" y1="' + bottom + '" x2="' + makerGapStart + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';
    svg += '<line x1="' + makerGapEnd + '" y1="' + bottom + '" x2="' + right + '" y2="' + bottom + '" stroke="#111111" stroke-width="' + borderMm + '" stroke-linecap="round"/>';

    return svg;
  }

  function buildSvgMarkup(state, config, sizeConfig, sizeKey, layout, face) {
    const rules = config.charRules;
    const badgeMap = config.badgeAssets[state.badge] || null;
    const badgeUrl = badgeMap ? (face === "front" ? badgeMap.white : badgeMap.yellow) : "";
let bgFill;

if (face === "front") {
  bgFill = "#e6eff5";
} else {
  bgFill = "#e79000";
}
    const overlayFill = "#15171c";
    const borderMm = layout.borderMm;
    const displayReg = layout.displayReg || "";
    const textCenterX = getTextCenterX(sizeConfig, rules, state.badge);
    const fontSizeMm = getFontSizeMm();
    const textY = sizeConfig.shape === "hex" ? 86 : 88;
    const supplierY = sizeConfig.heightMm - rules.supplierBottomOffsetMm;
    const bsauY = supplierY - 2.5;
    const supplierCenterX = textCenterX;
    const supplierRightX = sizeConfig.shape === "hex" ? (sizeConfig.widthMm - 26) : (sizeConfig.widthMm - 10);
    const letterSpacingEm = getLetterSpacingEm();
const sectionSafeId = "muzzStyle" + String(config.sectionId || "default").replace(/[^a-zA-Z0-9]/g, "") + face;

    let svg = "";
    svg += '<svg xmlns="http://www.w3.org/2000/svg"';
    svg += ' viewBox="0 0 ' + sizeConfig.widthMm + " " + sizeConfig.heightMm + '"';
    svg += ' preserveAspectRatio="xMidYMid meet"';
    svg += ' style="position:absolute;inset:0;width:100%;height:100%;display:block;">';

svg += '<defs>';
svg += '<linearGradient id="' + sectionSafeId + 'PlateShine" x1="0%" y1="0%" x2="0%" y2="100%">';
svg += '<stop offset="0%" stop-color="#ffffff" stop-opacity="0.08"/>';
svg += '<stop offset="28%" stop-color="#ffffff" stop-opacity="0.035"/>';
svg += '<stop offset="68%" stop-color="#000000" stop-opacity="0"/>';
svg += '<stop offset="100%" stop-color="#000000" stop-opacity="0.025"/>';
svg += '</linearGradient>';
svg += '</defs>';

svg += buildPlateShapeSvg(sizeConfig, bgFill);
svg += '<rect x="0" y="0" width="' + sizeConfig.widthMm + '" height="' + sizeConfig.heightMm + '" rx="4" ry="4" fill="url(#' + sectionSafeId + 'PlateShine)" opacity="1"/>';

    if (state.badge !== "None" && badgeUrl && sizeConfig.shape !== "hex") {
      svg += '<image href="' + escapeHtml(badgeUrl) + '" x="0" y="0" width="' + rules.badgeWidthMm + '" height="' + sizeConfig.heightMm + '" preserveAspectRatio="xMidYMid meet"/>';
    }

    svg += buildBrokenBorderSvg(sizeConfig, borderMm, state.badge, rules, supplierCenterX);

if (displayReg) {
  const previewStyle = slugStyle(state.style) === "4d-bevelled-edge"
    ? "2D Printed"
    : state.style;

  svg += buildStyledRegistrationTextSvg(
    displayReg,
    previewStyle,
    textCenterX,
    textY,
    fontSizeMm,
    letterSpacingEm,
    sectionSafeId
  );
}

    if (state.legalUse === "Road Legal") {
      svg += '<text x="' + supplierCenterX + '" y="' + supplierY + '" text-anchor="middle" fill="#111111" font-family="Arial, sans-serif" font-size="' + rules.supplierMarkingHeightMm + '" font-weight="700">MUZZPLATES</text>';
      svg += '<text x="' + supplierRightX + '" y="' + bsauY + '" text-anchor="end" fill="#111111" font-family="Arial, sans-serif" font-size="' + (rules.supplierMarkingHeightMm - 0.5) + '" font-weight="700">BS AU 145e</text>';
    }

    if (sizeConfig.shape === "hex") {
      svg += buildHexOverlaySvg(sizeConfig, sizeKey, overlayFill);
    }

    svg += "</svg>";
    return svg;
  }

  function getProductImage(product) {
    if (!product) return "";

    if (typeof product.featured_image === "string" && product.featured_image) {
      return product.featured_image;
    }

    if (product.featured_image && typeof product.featured_image.src === "string" && product.featured_image.src) {
      return product.featured_image.src;
    }

    if (
      product.featured_media &&
      product.featured_media.preview_image &&
      typeof product.featured_media.preview_image.src === "string" &&
      product.featured_media.preview_image.src
    ) {
      return product.featured_media.preview_image.src;
    }

    if (Array.isArray(product.media) && product.media.length) {
      var firstMedia = product.media[0];

      if (firstMedia && typeof firstMedia.src === "string" && firstMedia.src) {
        return firstMedia.src;
      }

      if (
        firstMedia &&
        firstMedia.preview_image &&
        typeof firstMedia.preview_image.src === "string" &&
        firstMedia.preview_image.src
      ) {
        return firstMedia.preview_image.src;
      }
    }

    if (Array.isArray(product.images) && product.images.length) {
      if (typeof product.images[0] === "string" && product.images[0]) {
        return product.images[0];
      }

      if (product.images[0] && typeof product.images[0].src === "string" && product.images[0].src) {
        return product.images[0].src;
      }
    }

    return "";
  }

  function getBadgeVariantId(position) {
    const handle = "plate-badge-upgrade";

    return fetch("/products/" + handle + ".js")
      .then(function(res) {
        return res.json();
      })
      .then(function(product) {
        var variant;

        if (position === "Front & Rear") {
          variant = product.variants.find(function(v) {
            return v.title.toLowerCase().indexOf("pair") !== -1;
          });
        } else {
          variant = product.variants.find(function(v) {
            return v.title.toLowerCase().indexOf("single") !== -1;
          });
        }

        return variant ? variant.id : null;
      });
  }
  function getBadgePricePence(badge, position) {
    if (!badge || badge === "None") return 0;
    return position === "Front & Rear" ? 500 : 250;
  }
  function updateCartBubble() {
    return fetch("/cart.js", {
      method: "GET",
      headers: {
        "Accept": "application/json"
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart fetch failed");
        return response.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;
        var cartIconBubble = document.getElementById("cart-icon-bubble");

        if (!cartIconBubble) return;

        var existingBubble = cartIconBubble.querySelector(".cart-count-bubble");

        if (count > 0) {
          if (!existingBubble) {
            existingBubble = document.createElement("div");
            existingBubble.className = "cart-count-bubble";
            cartIconBubble.appendChild(existingBubble);
          }

          existingBubble.innerHTML =
            '<span aria-hidden="true">' + count + '</span>' +
            '<span class="visually-hidden">' + count + ' item' + (count === 1 ? '' : 's') + '</span>';
        } else if (existingBubble) {
          existingBubble.remove();
        }
      })
      .catch(function (error) {
        console.error("Cart bubble update failed:", error);
      });
  }
  function initBuilder(root) {    const productsEl = root.querySelector("[data-builder-products]");
    const configEl = root.querySelector("[data-builder-config]");
    if (!productsEl || !configEl) return;

    const products = JSON.parse(productsEl.textContent || "{}");
    const config = JSON.parse(configEl.textContent || "{}");

    if (!config.sizes) return;

    config.sizes["Standard Size"] = { widthMm: 520, heightMm: 111, shape: "rect" };
    config.sizes['18" Short'] = { widthMm: 457, heightMm: 111, shape: "rect" };
    config.sizes['17" Short'] = { widthMm: 432, heightMm: 111, shape: "rect" };
    config.sizes['16" Short'] = { widthMm: 406, heightMm: 111, shape: "rect" };
    config.sizes['13" Short'] = { widthMm: 330, heightMm: 111, shape: "rect" };
    config.sizes["Hex 7"] = { widthMm: 520, heightMm: 111, shape: "hex" };
    config.sizes["Hex 6"] = { widthMm: 457, heightMm: 111, shape: "hex" };
    config.sizes["Hex 5"] = { widthMm: 406, heightMm: 111, shape: "hex" };

    const form = root.querySelector("[data-builder-form]");
    const regInput = root.querySelector('[data-builder-input="registration"]');
    const styleSelect = root.querySelector('[data-builder-input="style"]');
    const positionSelect = root.querySelector('[data-builder-input="position"]');
    const sizeSelect = root.querySelector('[data-builder-input="size"]');
    const badgeSelect = root.querySelector('[data-builder-input="badge"]');
    const borderSelect = root.querySelector('[data-builder-input="border"]');
    const variantIdInput = root.querySelector("[data-builder-variant-id]");
    const atcButton = root.querySelector("[data-builder-atc]");
    const atcNote = root.querySelector("[data-builder-atc-note]");
    const priceEl = root.querySelector("[data-builder-price]");
    const warningsEl = root.querySelector("[data-builder-warnings]");
    const fitEl = root.querySelector("[data-fit-status]");
    const fitLabelEl = root.querySelector("[data-fit-label]");
    const summaryProduct = root.querySelector("[data-summary-product]");
    const summaryVariant = root.querySelector("[data-summary-variant]");
    const frontCard = root.querySelector('[data-plate-card="front"]');
    const rearCard = root.querySelector('[data-plate-card="rear"]');
    const frontCanvas = root.querySelector('[data-plate-canvas="front"]');
    const rearCanvas = root.querySelector('[data-plate-canvas="rear"]');
    const styleImageCard = root.querySelector("[data-style-image-card]");
    const styleImageEl = root.querySelector("[data-style-image]");
    const styleImageTitleEl = root.querySelector("[data-style-image-title]");
const choiceButtons = root.querySelectorAll("[data-choice-target]");
    const availableStyles = (config.styleOrder || []).filter(function (style) {
      return !!products[style];
    });

    const state = {
      style: availableStyles[0] || "",
      position: "Front & Rear",
      legalUse: "Road Legal",
      size: "Standard Size",
      registration: "",
      badge: "None",
      border: "None",
      selectedVariant: null,
      selectedProduct: null
    };

    const prefill = parsePrefill();

    if (prefill.reg) state.registration = sanitizeRegistration(prefill.reg);

    if (prefill.style) {
      const matchedStyle = availableStyles.find(function (style) {
        return slugStyle(style) === String(prefill.style).toLowerCase();
      });
      if (matchedStyle) state.style = matchedStyle;
    }

    if (prefill.size && config.sizes[prefill.size]) state.size = prefill.size;
    if (prefill.badge && (config.badges || []).includes(prefill.badge)) state.badge = prefill.badge;
    if (prefill.border && (config.borders || []).includes(prefill.border)) state.border = prefill.border;
    if (prefill.position && (config.positions || []).includes(prefill.position)) state.position = prefill.position;

    if (regInput) regInput.value = state.registration;
    if (styleSelect) styleSelect.value = state.style;
    if (positionSelect) positionSelect.value = state.position;
    if (sizeSelect) sizeSelect.value = state.size;
    if (badgeSelect) badgeSelect.value = state.badge;
    if (borderSelect) borderSelect.value = state.border;

    function updatePreviewVisibility() {
      if (!frontCard || !rearCard) return;

      frontCard.hidden = false;
      rearCard.hidden = false;

      if (state.position === "Front Only") rearCard.hidden = true;
      if (state.position === "Rear Only") frontCard.hidden = true;
    }

    function enforceBorderRules() {
      if (!borderSelect) return;

      const sizeConfig = config.sizes[state.size];
      const isHex = sizeConfig && sizeConfig.shape === "hex";

      Array.from(borderSelect.options).forEach(function (option) {
        option.disabled = false;
      });

      if (isHex) {
        state.border = "None";
        borderSelect.value = "None";

        Array.from(borderSelect.options).forEach(function (option) {
          if (option.value !== "None") option.disabled = true;
        });
      }
    }

    function enforceBadgeRules() {
      if (!badgeSelect) return;

      const sizeConfig = config.sizes[state.size];
      const isHex = sizeConfig && sizeConfig.shape === "hex";

      Array.from(badgeSelect.options).forEach(function (option) {
        option.disabled = false;
      });

      if (isHex) {
        state.badge = "None";
        badgeSelect.value = "None";

        Array.from(badgeSelect.options).forEach(function (option) {
          if (option.value !== "None") option.disabled = true;
        });
      }
    }
    function updateBadgeOptionLabels() {
      if (!badgeSelect) return;

      Array.from(badgeSelect.options).forEach(function(option) {
        if (option.value === "None") {
          option.textContent = "None";
          return;
        }

        var extra = state.position === "Front & Rear" ? " (+£5.00)" : " (+£2.50)";
        option.textContent = option.value + extra;
      });
    }
    function resolveVariant() {
      const product = products[state.style];
      state.selectedProduct = product || null;
      state.selectedVariant = null;

      if (!product || !Array.isArray(product.variants)) return null;

      const variant = product.variants.find(function (item) {
        return item.option1 === state.position &&
          item.option2 === state.legalUse &&
          item.option3 === state.size;
      });

      state.selectedVariant = variant || null;
      return state.selectedVariant;
    }

function renderWarnings(items) {
  if (!warningsEl) return;

  let warningItems = items.slice();

  if (slugStyle(state.style) === "4d-bevelled-edge") {
    warningItems.push({
      state: "amber",
   text: "Bevelled Edge preview mode is currently behaving like a potato. We’d rather show you a clean 2D-style preview than a bad fake bevel. Use the style photos as reference. The real thing catches light properly and looks far better in person."
    });
  }

  warningsEl.innerHTML = warningItems.map(function (item) {
    return '<div class="muzz-builder-warning muzz-builder-warning--' + escapeHtml(item.state) + '">' + escapeHtml(item.text) + '</div>';
  }).join("");
}

    function renderPlate(canvas, face) {
      const sizeConfig = config.sizes[state.size];
      const rules = config.charRules;

      if (!canvas || !sizeConfig || !rules) return null;

      const borderValue = sizeConfig.shape === "hex" ? "None" : state.border;
      const layout = buildFitLayout(
        state.registration,
        state.legalUse,
        state.badge,
        borderValue,
        sizeConfig,
        state.size,
        rules
      );

const shell = canvas.parentElement;
const shellStyles = window.getComputedStyle(shell);

const shellInnerWidth =
  shell.getBoundingClientRect().width -
  parseFloat(shellStyles.paddingLeft || 0) -
  parseFloat(shellStyles.paddingRight || 0);

/*
  Stable preview sizing:
  - Standard 520mm plate is capped at 640px.
  - Short/hex plates scale from the same fixed base.
  - Preview can shrink only when the container is genuinely too narrow.
  - It will not grow just because the device rotates or rerenders.
*/
const previewBaseWidthPx = 640;
const previewReferenceWidthMm = 520;
const pxPerMm = previewBaseWidthPx / previewReferenceWidthMm;

const naturalWidthPx = Math.round(sizeConfig.widthMm * pxPerMm);
const availableWidth = Math.max(Math.floor(shellInnerWidth), 220);

const widthPx = Math.min(naturalWidthPx, availableWidth);
const heightPx = Math.round((sizeConfig.heightMm / sizeConfig.widthMm) * widthPx);

      canvas.className = "muzz-builder-plate-canvas " +
        (face === "front" ? "muzz-builder-plate-canvas--white" : "muzz-builder-plate-canvas--yellow") +
        (sizeConfig.shape === "hex" ? " is-hex" : "");

      canvas.style.width = widthPx + "px";
      canvas.style.height = heightPx + "px";
      canvas.innerHTML = buildSvgMarkup(state, config, sizeConfig, state.size, layout, face);

      return layout;
    }

    function updateFitDisplay(layout) {
      if (!fitEl || !fitLabelEl || !layout) return;

      fitEl.dataset.fitState = layout.fitState;
      fitLabelEl.textContent = layout.fitLabel;
    }

    function updateSummary(variant) {
      if (summaryProduct) {
        summaryProduct.textContent = state.selectedProduct ? state.selectedProduct.title : "Not selected";
      }

      if (variant) {
        if (summaryVariant) {
          summaryVariant.textContent = [variant.option1, variant.option2, variant.option3].filter(Boolean).join(" / ");
        }

        if (priceEl) {
          var totalPrice = Number(variant.price || 0) + getBadgePricePence(state.badge, state.position);
          priceEl.textContent = formatMoney(totalPrice);
        }
      } else {
        if (summaryVariant) {
          summaryVariant.textContent = "No matching variant";
        }
        if (priceEl) {
          priceEl.textContent = "£0.00";
        }
      }
    }

    function updateStyleImage() {
      if (!styleImageCard || !styleImageEl || !styleImageTitleEl) return;

      const product = state.selectedProduct;
      const imageUrl = getProductImage(product);

      if (!product || !imageUrl) {
        styleImageCard.hidden = true;
        styleImageEl.removeAttribute("src");
        styleImageEl.alt = "";
        styleImageTitleEl.textContent = "Not selected";
        return;
      }

      styleImageCard.hidden = false;
      styleImageEl.setAttribute("src", imageUrl);
      styleImageEl.alt = product.title || state.style || "Selected product image";
      styleImageTitleEl.textContent = state.style || product.title || "Selected Style";
    }

    function updateAtc(variant, fitState) {
      if (!atcButton || !variantIdInput || !atcNote) return;

      const canAdd = !!(variant && variant.available && fitState !== "red");

      atcButton.disabled = !canAdd;
      variantIdInput.value = canAdd ? String(variant.id) : "";

      if (!variant) {
        atcNote.textContent = "That combination does not match a live Shopify variant yet.";
      } else if (!variant.available) {
        atcNote.textContent = "That variant is currently unavailable.";
      } else if (fitState === "red") {
        atcNote.textContent = "Choose a valid size or remove the badge before adding to cart.";
      } else {
        atcNote.textContent = "Free fitting kit included with every order.";
      }
    }

    function rerender() {
      if (regInput) {
        state.registration = sanitizeRegistration(regInput.value);
        regInput.value = state.registration;
      }

      if (styleSelect) state.style = styleSelect.value;
      if (positionSelect) state.position = positionSelect.value;
      if (sizeSelect) state.size = sizeSelect.value;
      if (badgeSelect) state.badge = badgeSelect.value;
      if (borderSelect) state.border = borderSelect.value;

      enforceBorderRules();
      enforceBadgeRules();
      updateBadgeOptionLabels();
      updatePreviewVisibility();

      const variant = resolveVariant();

      const frontLayout = frontCard && !frontCard.hidden ? renderPlate(frontCanvas, "front") : null;
      const rearLayout = rearCard && !rearCard.hidden ? renderPlate(rearCanvas, "rear") : null;
      const activeLayout = rearLayout || frontLayout;

      updateFitDisplay(activeLayout);
      if (activeLayout) {
        renderWarnings(activeLayout.warnings);
        updateAtc(variant, activeLayout.fitState);
      }

updateSummary(variant);
updateStyleImage();
updateChoiceButtons();
    }
function updateChoiceButtons() {
  choiceButtons.forEach(function (button) {
    const target = button.dataset.choiceTarget;
    const value = button.dataset.choiceValue;

    if (state[target] !== undefined) {
      button.classList.toggle("is-active", value === state[target]);
    }
  });
}

choiceButtons.forEach(function (button) {
  button.addEventListener("click", function () {
    const target = button.dataset.choiceTarget;
    const value = button.dataset.choiceValue;

    const targetSelect = root.querySelector('[data-builder-input="' + target + '"]');

    if (targetSelect) {
      targetSelect.value = value;
      rerender();
    }
  });
});
    if (regInput) regInput.addEventListener("input", rerender);
    if (styleSelect) styleSelect.addEventListener("change", rerender);
    if (positionSelect) positionSelect.addEventListener("change", rerender);
    if (sizeSelect) sizeSelect.addEventListener("change", rerender);
    if (badgeSelect) badgeSelect.addEventListener("change", rerender);
    if (borderSelect) borderSelect.addEventListener("change", rerender);

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();

        if (!state.selectedVariant || !atcButton || atcButton.disabled) return;

        atcButton.disabled = true;
        atcButton.textContent = "Adding...";
        if (atcNote) atcNote.textContent = "Adding item to cart...";

        var items = [
          {
            id: state.selectedVariant.id,
            quantity: 1,
            properties: {
              Registration: state.registration || "",
              Badge: state.badge,
              Border: state.border,
              "Plate Style": state.style,
              "Plate Position": state.position,
              "Plate Size": state.size
            }
          }
        ];

        var badgePromise = Promise.resolve(null);

        if (state.badge && state.badge !== "None") {
          badgePromise = getBadgeVariantId(state.position);
        }

        badgePromise
          .then(function (badgeVariantId) {
            if (badgeVariantId) {
              items.push({
                id: badgeVariantId,
                quantity: 1,
                properties: {
                  Registration: state.registration || "",
                  Badge: state.badge,
                  "Plate Position": state.position,
                  "_linked_plate_style": state.style
                }
              });
            }

            return fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              },
              body: JSON.stringify({ items: items })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error("Add to cart failed");
            return response.json();
          })
          .then(function () {
            return updateCartBubble().then(function () {
              atcButton.textContent = "Added";
              if (atcNote) {
                if (state.badge && state.badge !== "None") {
                  atcNote.textContent = "Plate and badge upgrade added successfully.";
                } else {
                  atcNote.textContent = "Item added successfully.";
                }
              }
            });
          })
          .catch(function () {
            atcButton.textContent = "Add to cart";
            if (atcNote) atcNote.textContent = "There was a problem adding this item. Please try again.";
          })
          .finally(function () {
            window.setTimeout(function () {
              rerender();
              atcButton.textContent = "Add to cart";
            }, 900);
          });
      });
    }
    rerender();
let resizeTimer = null;

window.addEventListener("resize", function () {
  window.clearTimeout(resizeTimer);
  resizeTimer = window.setTimeout(rerender, 120);
});
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-muzz-builder]").forEach(initBuilder);
  });
})();
